import { ensureJourneyDb } from "../../db";
import { hydrateTransaction } from "./helpers";
import { listAccessibleTransactions, resolveActor } from "./access";

/** GET /api/transactions */
export function getAccessibleTransactions(session) {
  ensureJourneyDb();
  resolveActor(session);
  return listAccessibleTransactions(session).map(hydrateTransaction);
}

export function getTransactionCountByRole(session) {
  const rows = getAccessibleTransactions(session);
  return {
    total: rows.length,
    open: rows.filter((item) => item.status === "open").length,
    archived: rows.filter((item) => item.status !== "open").length,
  };
}
